import { Button, List, ListItem, Paper } from '@mui/material';
import React from 'react'
import { useOutletContext,useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import "./Report.css";
import BackIcon from '@mui/icons-material/KeyboardArrowLeft';

export default function Report(props)
{
	const { reportsContainer } = useOutletContext();
	const [reports] = reportsContainer;
	let report = reports[0];
	const navigate = useNavigate();

	const downloadExcel = () => {
		const worksheet = XLSX.utils.json_to_sheet([report]);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
		XLSX.writeFile(workbook, `${report.id}.xlsx`);
	};

	const back = ()=>{
		navigate(-1);
	};

	return (
		<div className='report'>
			<Paper elevation={12}>
				<Button startIcon={<BackIcon/>} variant='contained' sx={{ margin: "20px" }} onClick={back}>
					Back
				</Button>
				<Button variant='contained' sx={{ margin: "20px", float:"right" }} onClick={downloadExcel}>
					Export as Excel
				</Button>
				{report?
					<List>
					{
						Object.entries(report).map(([key, val]) => {
							return <ListItem key={key}>{key}: {val}</ListItem>  // I know this return will block the rest of teh code, that's intentional
							// if (key === "time" || key === "date")
							// 	return <ListItem key={key}>{key}: {new Date(val.seconds * 1000 + val.nanoseconds / 1000000).toString()}</ListItem>
							// else
							// 	return <ListItem key={key}>{key}: {val}</ListItem>
						})
					}
					</List>
				:null}
				
			</Paper>
		</div>
	)
}
